parseDescription